/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ b: NonNullable<unknown> }} Battery_MeasureInputs */



/**
* | output |
* | --- |
* | "Measurement: {b}" |
*
* @param {Battery_MeasureInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const battery_measure = /** @type {((inputs: Battery_MeasureInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Battery_MeasureInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Measurement: ${i?.b}`)
	return /** @type {LocalizedString} */ (`Mesure: ${i?.b}`)
});